<template>
  <div>
    <!-- eslint-disable -->
    <div v-if="!showSms">
      <form @submit.prevent="confirmReservationExecute()" class="mb-3 px-3 px-sm-0">
        <div class="row">
          <div class="col-12 col-sm-6">
            <label class="form-group w-100">
              <b>Nombres *</b>
              <input
              v-model="user.name"
              type="text"
              class="form-control"
              minlength="2"
              required
              autocomplete="off"
              >
            </label>
          </div>
          <div class="col-12 col-sm-6">
            <label class="form-group w-100">
              <b>Apellidos*</b>
              <input
              v-model.trim="user.lastName"
              type="text"
              class="form-control"
              minlength="4"
              required
              autocomplete="off"
              >
            </label>
          </div>
          <div class="col-12 col-sm-6">
            <label class="form-group w-100">
              <b>Tipo de documento*</b>
              <select
                v-model="user.documentType"
                class="form-control"
                required
                >
                <option v-for="doc in docTypes" :value="doc" :key="doc">
                  {{ doc }}
                </option>
              </select>
            </label>
          </div>
          <div class="col-12 col-sm-6">
            <label class="form-group w-100">
              <b>N° de documento*</b>
              <input
              v-model.trim="user.document"
              type="text"
              class="form-control"
              :minlength="user.documentType === 'DNI' ? 8 : 5"
              :maxlength="user.documentType === 'DNI' ? 8 : 15"
              required
              autocomplete="off"
              >
            </label>
          </div>
          <div class="col-12 col-sm-6">
            <label class="form-group w-100">
              <b>Email*</b>
              <input
              v-model.trim="user.email"
              type="email" autocomplete="off"
              class="form-control"
              :class="{'is-invalid': !hasValidEmail}"
              required
              @paste.prevent
              >
            </label>
          </div>
          <div class="col-12 col-sm-6">
            <label class="form-group w-100">
              <b>Confirmar Email*</b>
              <input
              v-model.trim="user.emailConfirm"
              type="email" autocomplete="off"
              class="form-control"
              :class="{'is-invalid': !hasValidEmail}"
              required
              @paste.prevent
              >
            </label>
          </div>
          <div class="col-12 col-sm-6">
            <b>Teléfono*</b>
            <div class="row">
              <div class="col-3">
                <label class="form-group mt-1">
                  <flags-dropdown name="code" v-on:change="optionSelected" :selected="user.countryIso"></flags-dropdown>
                </label>
              </div>
              <div class="col-9">
                <label class="form-group w-100">
                  <input
                  v-model.trim="user.phone"
                  type="tel"
                  class="form-control mt-1"
                  :minlength="user.cod === 51 ? 9 : 7"
                  :maxlength="user.cod === 51 ? 9 : 12"
                  required
                  autocomplete="off"
                  >
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div>
              <b>Aceptar*</b>
              <div class="custom-control custom-checkbox">
                <input
                v-model="user.terms"
                class="custom-control-input"
                type="checkbox"
                id="checkTerms"
                required
                >
                <label class="custom-control-label" for="checkTerms">
                  <a :href="termsPdf" target="_blank">
                    Términos y Condiciones.
                  </a>
                </label>
              </div>
              <div class="custom-control custom-checkbox">
                <input
                v-model="user.policies"
                class="custom-control-input"
                type="checkbox"
                id="checkPolicies"
                required
                >
                <label class="custom-control-label" for="checkPolicies">
                  <a :href="privacyPdf" target="_blank">
                    Políticas de Privacidad.
                  </a>
                </label>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="my-2 text-center">
              <b>Recuerda:</b><br>
              * Una vez realizado el pago, te <b>notificaremos a este email</b>.<br>
              * La persona responsable debe ser mayor de edad.
            </div>
          </div>
        </div>
        <div v-if="error || errorUser || errorSms" class="text-center mt-1 text-danger">
          {{ error }}
          {{ errorUser }}
          {{ errorSms }}
        </div>
        <div class="mt-2 d-flex flex-column-reverse flex-md-row justify-content-center">
          <slot></slot>
          <button class="btn btn-action btn-lg px-5 mx-2 mt-2" type="submit" :disabled="loading || loadingSms">
            <b-spinner v-if="loading || loadingSms" small class="mr-1"></b-spinner>
            Continuar
          </button>
        </div>
      </form>
    </div>
    <div v-else>
      <form @submit.prevent="verifyDataUserPay()" class="mb-3 px-3 px-sm-0">
        <div class="row">
          <div class="col-12 col-sm-6 mx-auto p-0 text-center">
            <small>Te hemos enviado un SMS con un código</small>
            <label class="form-group w-75 mx-1 mt-2">
              <input
                v-model.trim="user.codeSms"
                type="text" autocomplete="off"
                class="form-control"
                required
                placeholder="Inserta código SMS"
                style="text-align:center"
                maxlength="5"
              >
            </label>
            <p class="text-center">
              <small class="font-xs text-primary mr-1">¿No te llegó el código?</small>
              <a href="#" @click.prevent="confirmResendExecute()" class="font-xs"
              style="text-decoration:underline;">Clic aquí para reenviar</a>
            </p>
          </div>
          <div v-if="errorSms || error" class="col-12 text-center mt-1 text-danger">
            {{ error }}
            {{ errorSms }}
          </div>
          <div class="col-12 col-sm-8 mx-auto mt-2 d-flex flex-column-reverse flex-md-row justify-content-center">
            <button class="btn btn-outline-secondary btn-md px-4 mx-1 mt-2"
              type="button" @click="goBack()">
              Volver
            </button>
            <button class="btn btn-action btn-md px-4 mx-1 mt-2" type="submit"
              :disabled="loadingSms || loading">
              <b-spinner v-if="loadingSms || loading " small class="mr-1"></b-spinner>
              Continuar
            </button>
          </div>
        </div>
      </form>
    </div>
    <vue-recaptcha
      class="d-none"
      ref="invisibleRecaptcha"
      @verify="onVerify"
      @expired="onExpired"
      size="invisible"
      :sitekey="siteKey">
    </vue-recaptcha>
  </div>
</template>
<script>
// eslint-disable-next-line
import FlagsDropdown from 'flags-dropdown-vue';

import api from '../api';

const docTypes = ['DNI', 'CE', 'PASS'];

export default {
  components: {
    'flags-dropdown': FlagsDropdown,
  },
  props: ['error', 'loading', 'smsSend'],
  data() {
    return {
      docTypes,
      user: {
        name: '',
        lastName: '',
        documentType: 'DNI',
        document: '',
        email: '',
        emailConfirm: '',
        phone: '',
        terms: false,
        policies: false,
        countryIso: 'pe',
        cod: 51,
        codeSms: '',
        pinId: '',
      },
      showSms: false,
      loadingSms: false,
      errorSms: '',
      errorUser: '',
      resend: false,
    };
  },
  computed: {
    hasValidEmail() {
      if (this.user.email && this.user.emailConfirm) {
        return this.user.email === this.user.emailConfirm;
      }
      return true;
    },
  },
  methods: {
    verifyDataUserPay() {
      const { terms, policies } = this.user;
      if (!terms || !policies) return;
      this.$emit('submit', this.user);
    },
    optionSelected(data) {
      this.user.countryIso = data.iso;
      this.user.cod = data.phonecode;
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset();
    },
    onExpired() {
      this.resetRecaptcha();
    },
    onVerify(response) {
      // enviar SMS
      if (!this.resend) {
        this.sendSMS(response);
      } else if (this.user.pinId) {
        this.resendSMS(response);
      }
    },
    async confirmReservationExecute() {
      const regExp = new RegExp(/^[9]+[0-9]{6,12}$/);
      const result = regExp.test(this.user.phone);

      if ((!result && this.user.cod === 51) || this.user.phone.length < 7) {
        this.errorUser = 'Ingresa un número de teléfono válido';
        return;
      }

      let validate = true;
      this.errorUser = '';
      this.loadingSms = true;
      this.resend = false;
      if (this.user.documentType === 'DNI') {
        validate = await this.validateUser(this.user);
      }
      this.loadingSms = false;
      if (!validate) return;
      if (this.smsSend) {
        this.loadingSms = true;
        this.$refs.invisibleRecaptcha.execute();
      } else {
        this.verifyDataUserPay();
      }
    },
    confirmResendExecute() {
      this.loadingSms = true;
      this.resetRecaptcha();
      this.$refs.invisibleRecaptcha.execute();
    },
    async sendSMS(token) {
      try {
        this.errorSms = '';
        const phone = `+${this.user.cod}${this.user.phone}`;
        const payload = {
          phone,
          token,
          email: this.user.email,
          source: this.projectKey,
        };
        const url = `${api.nodeUrl}/sms/send`;
        const { data: res } = await api.axios.post(url, payload);

        this.loadingSms = false;
        if (!res.status) {
          this.errorSms = res.message;
          this.resetRecaptcha();
          return false;
        }
        if (res.data.reliableBuyer) {
          this.verifyDataUserPay();
          return false;
        }
        this.user.pinId = res.data.pinId;
        this.showSms = true;
        this.resend = true;
        return true;
      } catch (err) {
        this.errorUser = 'Error, inténtalo en un momento.';
        setTimeout(() => {
          this.errorUser = '';
        }, 9000);
        return false;
      }
    },
    async resendSMS(token) {
      try {
        this.errorSms = '';
        const { pinId } = this.user;
        const phone = `+${this.user.cod}${this.user.phone}`;
        const url = `${api.nodeUrl}/sms/resend`;
        const { data: res } = await api.axios.post(url, { phone, pinId, token });

        this.loadingSms = false;
        if (!res.status) {
          this.errorSms = res.message;
          this.resetRecaptcha();
          return false;
        }
        this.user.pinId = res.data.pinId;
        this.showSms = true;
        return true;
      } catch (err) {
        this.errorUser = 'Error, inténtalo en un momento.';
        setTimeout(() => {
          this.errorUser = '';
        }, 9000);
        return false;
      }
    },
    goBack() {
      this.showSms = false;
      this.resend = false;
      this.resetRecaptcha();
    },
    async validateUser(user) {
      try {
        const url = `${api.nodeUrl}/validate-documents`;
        const { data: res } = await api.axios.post(url, [user]);
        if (!res.data[0].status) {
          this.errorUser = res.data[0].message;
          return false;
        }
        return true;
      } catch (err) {
        this.errorUser = 'Error, inténtalo en un momento.';

        setTimeout(() => {
          this.errorUser = '';
        }, 9000);
        return false;
      }
    },
  },
};
</script>
<style src="flags-dropdown-vue/css/flags.min.css"></style>
<style src="flags-dropdown-vue/css/custom.css"></style>
<style>
.lang-dropdown {
    cursor: pointer;
}
.flag-box{
  border-radius: 3px;
  border: 1px solid #c2c2c2 !important;
  padding: 0 2px;
  height: calc(1.5em + 0.75rem + 2px);
}
</style>
